goog.provide("shadow.js.shim.module$app$main$data$shortcuts_impl_js$default");
shadow.js.shim.module$app$main$data$shortcuts_impl_js$default = module$app$main$data$shortcuts_impl.default;
